import React from 'react';
import moment from 'moment';
import { Box, Typography } from '@mui/material';

const DonorLinkLoggedItemsMessage = ({ items = [], nextPickup = null }) => (
  <Box data-testid="donor-link-logged-items-message">
    <Typography variant="body1" gutterBottom>
      Food items have already been logged for this rescue.{' '}
      {nextPickup
        ? 'Do you want to move them to the next pickup in the schedule?'
        : 'There is no upcoming pickup in this schedule to move them to, so they will be discarded.'}
    </Typography>

    {nextPickup && (
      <Typography variant="body1" gutterBottom>
        Move logged items to rescue on: <strong>{moment(nextPickup.date, 'YYYY-MM-DD').format('dddd, MMMM Do')}</strong>
      </Typography>
    )}

    {nextPickup && nextPickup.has_logged_items && (
      <Typography variant="body2" color="textSecondary" gutterBottom>
        That pickup already has logged items, these will be added to them.
      </Typography>
    )}

    <Typography variant="body1">Logged items:</Typography>
    <Box component="ul" mt={0}>
      {items.map((item) => (
        <li key={`${item.name}-${item.quantity}-${item.value}`}>
          <Typography variant="body2">{`${item.name} (${item.quantity}x)`}</Typography>
        </li>
      ))}
    </Box>

    <Typography variant="body2" color="textSecondary">
      Make sure you contact the donor and let them know you won&apos;t be picking up on this date!
    </Typography>
  </Box>
);

export default DonorLinkLoggedItemsMessage;
